const enum DateFormat {
  DEFAULT = "DD.MM.YYYY HH:mm",
  ONLY_TIME = "HH:mm",
  ONLY_DATE = "DD.MM.YYYY",
}

export default DateFormat;
